export const TECH_HIGHLIGHTS_KEY = 'techHighlights';
export const INITIAL_LABELS_STATE = {
    productCard_productDescription_label: '',
    productCard_gallery_label: '',
    productCard_expandGalleryButton_alt: '',
    productCard_previousItemGalleryButton_alt: '',
    productCard_nextItemGalleryButton_alt: '',
    productCard_closeGalleryButton_alt: '',
    productCard_total_label: '',
    productCard_addToCartButton_label: '',
    productCard_outOfStockButton_label: '',
    productCard_requestTestRideButton_label: '',
    productCard_paymentOptions_label: '',
    productCard_downloadImageButton_label: '',
    productCard_360viewEnterButton_label: '',
    productCard_360viewExitButton_label: '',
    productCard_360viewLoading_text: '',
    productCard_360view_hint: '',
    productCard_colorSelector_label: '',
    productCard_successAddToCartPopUpContinueShopping_button: '',
    productCard_successAddToCartPopUpGoToCart_button: '',
    productCard_successAddToCartPopUp_header: '',
    productCard_successAddToCartPopUp_message: '',
    productCard_outOfStockError_message: '',
    productCard_incompatibleCartGroupError_message: '',
    productCard_cartUpdateError_message: '',
    notifyMe_emailReceived_message: '',
    notifyMe_getNotified_link: '',
    notifyMe_gotIt_button: '',
    notifyMe_invalidEmailFormat_error: '',
    notifyMe_notifyMeBackInStock_header: '',
    notifyMe_notifyMe_button: '',
    notifyMe_stopKeepingEmailMessage_message: '',
    notifyMe_variantNotAvailable_message: '',
    notifyMe_enterYourEmail_placeholder: '',
    notifyMe_keepMeInformed_message: '',
    notifyMe_getNotifiedAboutProduct_label: '',
    notifyMe_keepMeInformedTitle_description: '',
    notifyMe_enterYourFirstName_placeholder: '',
    notifyMe_enterYourLastName_placeholder: '',
    notifyMe_pleaseFillInField_error: '',
    notifyMe_productAnnouncementEmailReceived_message: '',
    notifyMe_enterYourPhoneNumber_placeholder: '',
    common_cancel_button: '',
    common_somethingWentWrong_message: '',
    common_email_label: '',
    common_firstName_label: '',
    common_lastName_label: '',
    common_phoneNumber_label: '',
    common_success_label: '',
    common_error_label: '',
    common_countryNameOrCode_label: '',
    common_lowStock_message: 'Only {count} items left',
    common_or_label: '',
    // labels for filter section
    productCard_needHelpWithConfigurations_message: '',
    productCard_rotation_label: '',
    productCard_shaftLength_label: '',
    productCard_startingMethodAndTilt_label: '',
    productCard_controlMethod_label: '',
    productCard_frameSize_label: '',
    productCard_viewSizeGuide_link: '',
    product_frameSizeSmall_label: '',
    product_frameSizeMedium_label: '',
    product_frameSizeLarge_label: '',
    // Modified keys of label. need refactor with removing this extra labels
    addToCartButtonLabel: '',
    closeGalleryButtonAlt: '',
    downloadImageButtonLabel: '',
    expandGalleryButtonAlt: '',
    galleryLabel: '',
    nextItemGalleryButtonAlt: '',
    outOfStockButtonLabel: '',
    previousItemGalleryButtonAlt: '',
    productDescriptionLabel: '',
    requestTestRideButtonLabel: '',
    view360EnterButtonLabel: '',
    view360ExitButtonLabel: '',
    view360LoadingText: '',
    view360Hint: '',
    product_size_label: '',
    partsAccessoriesMerch_volume_label: '',
    partsAccessoriesMerch_weight_label: '',
    productCard_santanderPayInInstalments_title: '',
    productCard_leasingCard_title: '',
    productCard_leasingCard_loginToApply: '',
    productCard_leasingCard_apply: '',
    productCard_leasingCard_description: '',
    partsAccessoriesMerch_QuantitySelect_header: '',
    partsAccessoriesMerch_addToCartPopUpNeedToCheckCompatibility_description: '',
    partsAccessoriesMerch_addToCartPopUpIncompatibleModel_description: '',
    partsAccessoriesMerch_addToCartPopUpMissingRequiredItems_description: '',
    partsAccessoriesMerch_addToCartPopUpBackToPage_button: '',
    partsAccessoriesMerch_addToCartPopUpProceedToCart_button: '',
    partsAccessoriesMerch_addToCartPopUpAnyway_button: '',
    partsAccessoriesMerch_addToCartPopUpCompatibility_button: '',
    partsAccessoriesMerch_addToCartPopUpYouSure_header: '',
    partsAccessoriesMerch_addToCartPopUpMissingInfo_header: '',
    partsAccessoriesMerch_checkCompatibility_link: '',
    partsAccessoriesMerch_checkCompatibilityAlert_description: '',
    partsAccessoriesMerch_resetModelPopUp_description: '',
    partsAccessoriesMerch_resetModel_link: '',
    hostettler_tooManyTotalItems_message: '',
    hostettler_tooManyItemsOfTheSameProduct_message: '',
    hostettler_notPossibleToAddThisQuantity_message: '',
    hostettler_errorAddingRemovingItems_message: '',
    common_tryAgain_label: '',
};
export const INITIAL_FILTER_OPTIONS_STATE = {
    // Common option
    sku: '',
    colourId: '',
    colorItemIndex: 0,
    // Options for 'Engine'
    rotation: '',
    shaftLength: '',
    startingMethod: '',
    controlMethod: '',
    // Options for 'eBike'
    size: '',
    // Options for 'scooters or boats'
    productOption: '',
    // Options for 'motorcycles'
    power: '',
    transmission: '',
    loweredVersion: '',
    // Prop for define current filter options
    productType: '',
    // External validation prop
    isVarianAvailable: true,
    isFilterChanged: false,
};
